'use strict';

/* eslint no-undef: "off" */
/**
 * stores app
 */
define('storeViewApp',['storeViewMain', 'headerNavbar', 'footerWrapper', 'headerWrapper', 'sideMenu', 'searchPanel', 'GAReport'], function (storeViewMain, headerNavbar, footerWrapper, headerWrapper, sideMenu, searchPanel, GAReport) {
  new GAReport().init({
    pageGroup: "STORES"
  });
  return {
    template: '\n      <div class="page-container in-stores">\n        <side-menu></side-menu>\n        <header-wrapper></header-wrapper>\n        <search-panel></search-panel>\n        <header-navbar :show-back-btn="true" :light="true" :showMenuBtn="true" :title="i18n.storeDetail" />\n        <store-view-main></store-view-main>\n<!--        <footer-wrapper pageId="home"></footer-wrapper>-->\n      </div>\n    ',
    data: function data() {
      return {
        i18n: {
          storeDetail: 'Store Detail'
        }
      };
    },

    components: {
      storeViewMain: storeViewMain,
      headerNavbar: headerNavbar,
      headerWrapper: headerWrapper,
      sideMenu: sideMenu,
      searchPanel: searchPanel
      // footerWrapper,
    }
  };
});
